import axios from 'axios';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';

export const listCollections = () =>
  axios.get(`${getV2RootUrl()}/collection/for-web`, publicAxiosHeaderV2());
